export default __webpack_public_path__ + "static/media/mintIcon.93e2ca58.svg";